import api from './axios'; 

const permissionsRequest = {
    getAll(){
        return api.get('/permission')
    },
    save(form){
        return api.post('/permission',form)
    },
    update(id,form){
        return api.patch(`/permission/${id}`,form)
    },
    delete(id){
        return api.delete(`/permission/${id}`)
    }
}

export default permissionsRequest